import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { TokenService } from 'src/app/core/service/autenticacao/token.service';

@Directive({
  selector: '[temPermissao]'
})
export class TemPermissaoDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set temPermissao(permissaoId: string) {
    this.viewContainer.clear();

    if (TokenService.PossuiPermissaoGlobal(permissaoId)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
